module.exports = __webpack_public_path__ + "img/ic_32_exercises_cooldown.e9f4ff2d.svg";